export const SUBSCRIPTION = {
  STANDARD: 'standard',
  PREMIUM: 'premium',
  PRIVILEGE: 'privilege',
  ESSENTIAL: 'essential',
  PLUS: 'plus',
  PRO: 'pro',
  ENTERPRISE: 'enterprise',
};

export const SUBSCRIPTIONS = Object.values(SUBSCRIPTION);

export const DEFAULT_SUBSCRIPTION = SUBSCRIPTION.STANDARD;
